<div class="loadWrapper">
    <div class="loader">
        <img src="../../../assets/pliq-play.svg" alt="">
    </div>
</div>
